const roles = {
    business: 'Business',
    nutricionist: 'Nutritionist',
    user: 'Customer',
}

export default roles;